var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBorn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6 5.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-white{fill:#fff; stroke: #fff; stroke-width: 0.2}\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-white",
    d: "M0 2.47h6v.5H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-white",
    transform: "rotate(-60 -20.104 1087.54)",
    d: "M927.93 564.88h6v.5h-6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-white",
    transform: "rotate(-29.9 -586.126 2021.564)",
    d: "M930.69 562.13h.5v6h-.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBorn);
export default __webpack_public_path__ + "static/media/icon_born.5620f458.svg";
export { ForwardRef as ReactComponent };